import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container text-center" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "h1 mt-4 pt-4 col-6 justify-content-center" }, " Check Calls ", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "col-4 col-sm-1 text-top m-0 p-0",
  src: "StartDuty.png"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-light h3 mt-2 pt-4" }, " Start Duty Call ", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "col-4 col-sm-1 text-top m-0 p-0",
  src: "StartDuty.png"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-light h3 mt-2 pt-4" }, " Duty Check Call ", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "col-4 col-sm-1 text-top m-0 p-0",
  src: "StartDuty.png"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-light h3 mt-2 pt-4" }, " End Duty Call ", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.GetCurrentJobsForOfficer && $setup.GetCurrentJobsForOfficer(...args))),
          class: "btn btn-danger col-5 col-sm-2 m-4 p-4"
        }, " Refresh Check Calls ")
      ]),
      ($setup.StartingJob != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
            $setup.DutyCommand($setup.StartingJob.jobId, 2, 1, 'job-started', 'start test')
          )),
              class: "container row"
            }, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      ($setup.RunningJob != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
            $setup.DutyCommand($setup.RunningJob.jobId, 0, 2, 'check-call', 'check-call test')
          )),
              class: "container row"
            }, _hoisted_11)
          ]))
        : _createCommentVNode("", true),
      ($setup.EndingJob != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.DutyCommand($setup.EndingJob.jobId, 9, 3, 'job-ended', 'end test'))),
              class: "container row"
            }, _hoisted_15)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}